import React, { useEffect, useRef } from 'react';

const SelectCheckbox = ({ checked, indeterminate = false, onChange, ariaLabel, className = '' }) => {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);

  return (
    <input
      ref={checkboxRef}
      type="checkbox"
      className={className}
      checked={Boolean(checked)}
      onChange={onChange}
      aria-label={ariaLabel}
    />
  );
};

export default SelectCheckbox;
